import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import VksReadyModal from '../../../../../../Components/VksInviteComponents/VksReadyModal/VksReadyModal';
import { createVks } from '../../../../../../Store/VksReducer/vksActions';
import { LinkButton } from '../link-button'
import Icon from '@ant-design/icons';

export const SidebarVKSButton = (props)=>{
    const dispatch = useDispatch()
    const {hasVks, vksLink, vksParts} = useSelector(state=>state.vks)
    const currentURL = window.location.protocol + '//' + window.location.host;
    const createVksHandler = () => {
        if(hasVks){
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                title: 'Видеоконференции на портале Asista',
                html: 
                    <VksReadyModal currentURL={currentURL} vksParts={vksParts} vksLink={vksLink} id={props.id}/>,
                showConfirmButton: false,
                showCloseButton: false
            
            }).then(result => {
                if(result.isConfirmed){
                    window.location.assign(vksLink)
                }
            })
        }else{
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                title: 'Видеоконференции на портале Asista',
                html: 
                    <div> 
                        Для одного клиента-компании мы создаем комнату для проведения внутренних конференций.
                        Вы можете отправить ссылку на нее всем участникам конференции и в указанное время решать рабочие вопросы.
                        Нажмите «Создать видеоконференцию», и вы автоматически попадете в комнату, созданную специально для вашей компании. 
                        <br/>
                        <br/>*Для абонентов IT Support Group данный сервис является бесплатным. Мы не используем персональные данные, озвученные в ходе видеоконференции.
                        <div className='Modal__buttons'>
                            <button type="button" onClick={()=>dispatch(createVks(props.id))} className="VksInviteModule__blue_button" >
                                Создать комнату
                            </button>
                            <button type="button" onClick={()=>Swal.close()} className="VksInviteModule__form_submit">
                                Отменить
                            </button>  
                        </div>
                    </div>,
                showConfirmButton: false,
                showCloseButton: false
            })
        }
    }
    return (
        <LinkButton
            icon={
                <Icon
                    component={() => (
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 12 12" fill="none">
                            <path d="M7.73082 4.84578L10.3574 3.53247C10.741 3.34068 11.1924 3.61962 11.1924 4.04849V7.95076C11.1924 8.37963 10.741 8.65857 10.3574 8.46677L7.73082 7.15347M1.96159 9.46116H6.57697C7.21422 9.46116 7.73082 8.94457 7.73082 8.30732V3.69193C7.73082 3.05468 7.21422 2.53809 6.57697 2.53809H1.96159C1.32433 2.53809 0.807739 3.05468 0.807739 3.69193V8.30732C0.807739 8.94457 1.32433 9.46116 1.96159 9.46116Z" stroke="currentColor" stroke-width="0.923077" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    )}
                />
            }
            onClick={createVksHandler}
            children={hasVks ? 'Перейти в ВКС' : 'Создать ВКС'}
            open={props.open}
        />
    )
}